import {Component} from '@angular/core';
import {CardsSortEnum} from "./cards-sort.enum";
import {CardsSortDialogService} from "./cards-sort-dialog.service";
import {CardsSortOptionModel} from "./cards-sort-option.model";

@Component({
  selector: 'app-cards-sort-dialog',
  templateUrl: './cards-sort-dialog.component.html',
  styleUrl: './cards-sort-dialog.component.scss'
})
export class CardsSortDialogComponent {
  protected readonly SORT_OPTIONS: CardsSortOptionModel[] = [
    {sort: CardsSortEnum.NEWEST_TO_OLDEST, isSelected: false},
    {sort: CardsSortEnum.OLDEST_TO_NEWEST, isSelected: false},
    {sort: CardsSortEnum.A_TO_Z, isSelected: false},
    {sort: CardsSortEnum.Z_TO_A, isSelected: false},
  ];

  protected selectSort(option: CardsSortOptionModel): void {
    for (const sortOption of this.SORT_OPTIONS) {
      sortOption.isSelected = sortOption.sort == option.sort;
    }

    const isNotSameOptionClicked = option.sort != CardsSortDialogService.sort.value;
    if(isNotSameOptionClicked) {
      CardsSortDialogService.sort.next(option.sort);
    }
  }
}
